export class NgxGalleryOrder {
  static Column = 1;
  static Row = 2;
  static Page = 3;
}



// WEBPACK FOOTER //
// /agir/src/app/components/ngx-gallery/ngx-gallery-order.model.ts